// extracted by mini-css-extract-plugin
export var active = "_dw-7";
export var blink = "_dw-8";
export var dropDownSelector = "_dw-4";
export var dropDownWrapper = "_dw-3";
export var fakeCursor = "_dw-6";
export var fontSizeButton = "_dw-9";
export var formQuillEditor = "_dw-0";
export var pressed = "_dw-a";
export var qlBlank = "_dw-1";
export var textFormattingToolbar = "_dw-2";
export var textToolbarOption = "_dw-5";